import { SEND_ANALYTICS, SendAnalyticsAPI } from '@weblite-wapps/protocol'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'

wappSubscription.subscribe<SendAnalyticsAPI>(
  SEND_ANALYTICS,
  (payload, meta) => {
    analite(payload.type, payload.data, meta.wappId, meta.wisId)
    return { status: 'ok' }
  },
)
